import { render, staticRenderFns } from "./Importphoto.vue?vue&type=template&id=0b6630c2&"
import script from "./Importphoto.vue?vue&type=script&lang=js&"
export * from "./Importphoto.vue?vue&type=script&lang=js&"
import style0 from "./Importphoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports